<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-12">
        <h2>{{ $t('market_reports') }}</h2>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'dashboard' }">
              {{ $t('dashboard') }}
            </router-link>
          </li>
          <li class="active">
            <strong>{{ $t('market_reports') }}</strong>
          </li>
        </ol>
        <!-- <button class="btn btn-white btn-lg help-breadcrumb" @click="help" data-toggle="tooltip" data-placement="bottom" title="Ajuda"><i class="fa fa-question help-button"></i></button> -->
        <img :src="logo" class="logo-instituicao" />
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="row">
        <div class="col-md-12">
          <div class="tabs-container m-b-lg">
            <ul class="nav nav-tabs">
              <li
                v-for="(tab, index) in tabs"
                v-if="tab.buttons.length > 0"
                :id="`tab-header-${index}`"
                :key="index"
              >
                <a
                  data-toggle="tab"
                  :href="`#${index}`"
                  @click="selectTab(tab)"
                >
                  {{ tab.nome }}
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div
                v-for="(tab, index) in tabs"
                v-if="tab.buttons.length > 0"
                :id="index"
                :key="index"
                class="tab-pane"
              >
                <div class="panel-body">
                  <h5>{{ $t('select_report_type') }}</h5>
                  <div class="row">
                    <div class="col-md-12">
                      <ul
                        :id="`type-list-${index}`"
                        class="list-inline arquivo m-b"
                      >
                        <li
                          v-for="button in tab.buttons"
                          :key="button.nome"
                          class="arquivo-item"
                        >
                          <div @click="selectType(button, tab.buttons, tab)">
                            <img
                              :src="button.imagem"
                              class="arquivo-img img-circle"
                              :class="{ selected: button.selected }"
                            />
                            <h5 class="arquivo-nome">{{ button.nome }}</h5>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <h4>{{ $t('filters') }}</h4>
                    </div>
                    <div class="col-md-2">
                      <div :id="`ano-${index}`" class="form-group">
                        <datepicker
                          v-if="tab.reload"
                          :change="setAno(tab)"
                          :min="2"
                          format="yyyy"
                          :placeholder="$t('year')"
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div :id="`mes-${index}`" class="form-group">
                        <datepicker
                          v-if="tab.reload"
                          :change="setMes(tab)"
                          :min="1"
                          :max="1"
                          format="MM"
                          :placeholder="$t('month')"
                        />
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div :id="`nome-${index}`" class="form-group">
                        <input
                          v-model="tab.filters.nome"
                          type="text"
                          class="form-control"
                          :placeholder="$t('title')"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <button
                        :id="`remove-filters-${index}`"
                        class="btn btn-danger"
                        @click="clearFilters(tab)"
                      >
                        {{ $t('remove_filters') }}
                      </button>
                      <button
                        :id="`apply-filters-${index}`"
                        class="btn btn-primary"
                        @click="applyFilters(tab)"
                      >
                        {{ $t('apply_filters') }}
                      </button>
                      <div class="hr-line-dashed" />
                    </div>
                  </div>
                  <div :id="`page-size-${index}`" class="form-group">
                    <label>
                      {{ $t('items_per_page') }}
                      <select
                        v-model="tab.pagination.pageSize"
                        class="form-control input-sm n-itens"
                        @change="selectPageSize(tab, $event.target.value)"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </label>
                  </div>
                  <div class="wrapper-table">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th class="th-sm">{{ $t('date') }}</th>
                          <th>{{ $t('title') }}</th>
                          <th class="text-center actions-lg">
                            {{ $t('download') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody :id="`table-${index}`">
                        <tr
                          v-for="(item, itemIndex) in tab.items"
                          :key="itemIndex"
                        >
                          <td>{{ item.fData }}</td>
                          <td>{{ item.Nome }}</td>
                          <td
                            :id="`download-file-${itemIndex}-${index}`"
                            class="text-center"
                          >
                            <a
                              class="action-icon"
                              style="cursor: pointer"
                              @click="downloadFile(item.Id)"
                            >
                              <i class="fa fa-download fa-fw text-navy" />
                            </a>
                          </td>
                        </tr>
                        <tr v-if="tab.items.length === 0">
                          <td colspan="4">{{ $t('no_item_found') }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div :id="`paginate-${index}`">
                    <paginate
                      :selected="tab.pagination.page - 1"
                      :page-count="tab.pagination.pageCount"
                      :click-handler="load(tab)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseSteps } from '../../lib/tour'
import hopscotch from 'hopscotch'
import { filter } from 'lodash'
import $ from 'jquery'
import store from '../../store'
import { Paginate } from '../../shared'
import { mapGetters, mapActions } from 'vuex'
import base from '../../store/base'
import axios from 'axios'
import { getUserData } from '../../lib/token'
import Noty from 'noty'
import Datepicker from '../../components/Datepicker'
import hideLoading from '../../lib/hideLoading'

export default {
  name: 'MercadoIndex',
  components: {
    Datepicker,
    Paginate
  },
  beforeRouteEnter(to, from, next) {
    const userData = getUserData()
    if (userData) {
      const { access_token } = userData
      axios.defaults.headers.common['Authorization'] = `bearer ${access_token}`
    }

    Promise.all([
      store.dispatch('ping/requestData'),
      store.dispatch('mercado/requestData')
    ]).then(() => next())
  },
  beforeRouteLeave(to, from, next) {
    hopscotch.endTour(true)
    next()
  },
  created() {
    document.title = 'Relatórios de Mercado - IMEA'
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')

    const instituicaoData = JSON.parse(
      localStorage.getItem('imea.portal.instituicao')
    )

    this.instituicaoId = instituicaoData.Id

    const tabs = filter(this.tabs, tab => tab.buttons.length > 0)
    if (tabs[0]) this.selectTab(tabs[0])
    document.title = `${this.$t('market_reports')} - IMEA`
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')

    const str = window.localStorage.getItem('imea.portal.instituicao')
    if (str) {
      const data = JSON.parse(str)
      if (data) {
        this.logo = data.Logo
      }
    }
  },
  mounted() {
    hideLoading()
    $('.nav-tabs a:first').tab('show')
  },
  computed: {
    ...mapGetters('mercado', ['tabs'])
  },
  methods: {
    async downloadFile(arquivoId) {
      const url = `${base}/arquivo/download`

      const response = await axios.get(url, {
        params: { id: arquivoId, instituicao: this.instituicaoId }
      })

      const notification = new Noty({
        type: 'success',
        text: `<h3>${this.$t('download_ready')}</h3>`,
        buttons: [
          Noty.button(this.$t('download'), 'btn btn-primary', function() {
            window.open(response.data.Path, '_blank')
            notification.close()
          })
        ],
        theme: 'bootstrap-v3'
      }).show()
    },
    help() {
      hopscotch.startTour(this.tour)
    },
    selectTab(tab) {
      const index = this.tabs.indexOf(tab)
      const steps = this.tour.steps.filter(step => step.tab)
      steps.forEach(step => {
        const text = step.target.slice(0, -2)
        step.target = `${text}-${index}`
      })
      this.applyFilters(tab)
    },
    selectPageSize(tab, value) {
      tab.filters.pageSize = value
      if (this.permFilters[tab.cadeia]) {
        this.permFilters[tab.cadeia].pageSize = value
        const {
          cadeia,
          tipo,
          ano,
          mes,
          nome,
          categoria,
          pageSize,
          page
        } = this.permFilters[tab.cadeia]
        this.loadData({
          cadeia,
          tipo,
          ano,
          mes,
          nome,
          categoria,
          pageSize,
          page
        })
      }
    },
    load(tab) {
      return value => {
        tab.filters.page = value
        tab.pagination.page = value
        if (this.permFilters[tab.cadeia]) {
          this.permFilters[tab.cadeia].page = value
          const {
            cadeia,
            tipo,
            ano,
            mes,
            nome,
            categoria,
            pageSize,
            page
          } = this.permFilters[tab.cadeia]
          this.loadData({
            cadeia,
            tipo,
            ano,
            mes,
            nome,
            categoria,
            pageSize,
            page
          })
        }
      }
    },
    selectType(button, buttons, tab) {
      buttons.forEach(b => {
        b.selected = false
      })
      button.selected = true
      this.applyFilters(tab)
    },
    refresh(tab) {
      tab.reload = false
      setTimeout(() => {
        tab.reload = true
      })
    },
    clearFilters(tab) {
      tab.filters.ano = ''
      tab.filters.mes = ''
      tab.filters.nome = ''
      this.refresh(tab)
    },
    applyFilters(tab, page) {
      const categoria = '2'
      const { cadeia, buttons, filters } = tab
      const { ano, mes, nome, pageSize } = filters
      const button = buttons.find(b => b.selected)
      const tipo = button ? button.id : ''
      if (!page) {
        page = '1'
      }
      this.permFilters[cadeia] = {
        cadeia,
        tipo,
        ano,
        mes,
        nome,
        categoria,
        pageSize,
        page
      }
      this.loadData({ cadeia, tipo, ano, mes, nome, categoria, pageSize, page })
    },
    setAno(tab) {
      return data => {
        tab.filters.ano = data ? data.getFullYear() : ''
      }
    },
    setMes(tab) {
      return data => {
        tab.filters.mes = data ? data.getMonth() + 1 : ''
      }
    },
    ...mapActions('mercado', ['loadData'])
  },
  data() {
    return {
      instituicaoId: '',
      tour: {
        id: 'dashboard-tour',
        showPrevButton: true,
        i18n: {
          nextBtn: this.$t('tour_next'),
          prevBtn: this.$t('tour_prev'),
          doneBtn: this.$t('tour_done'),
          skipBtn: this.$t('tour_skip'),
          closeTooltip: this.$t('tour_close'),
          stepNums: ['1', '2', '3']
        },
        steps: baseSteps.concat([
          {
            title: this.$t('market_view.tour_one_title'),
            content: this.$t('market_view.tour_one_content'),
            target: 'tab-header-0',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('market_view.tour_two_title'),
            content: this.$t('market_view.tour_two_content'),
            target: 'type-list-0',
            placement: 'bottom',
            yOffset: -20,
            xOffset: 20
          },
          {
            tab: true,
            title: this.$t('market_view.tour_three_title'),
            content: this.$t('market_view.tour_three_content'),
            target: 'ano-0',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('market_view.tour_four_title'),
            content: this.$t('market_view.tour_four_content'),
            target: 'mes-0',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('market_view.tour_five_title'),
            content: this.$t('market_view.tour_five_content'),
            target: 'nome-0',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('market_view.tour_six_title'),
            content: this.$t('market_view.tour_six_content'),
            target: 'remove-filters-0',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('market_view.tour_seven_title'),
            content: this.$t('market_view.tour_seven_content'),
            target: 'apply-filters-0',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('market_view.tour_eight_title'),
            content: this.$t('market_view.tour_eight_content'),
            target: 'page-size-0',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('market_view.tour_nine_title'),
            content: this.$t('market_view.tour_nine_content'),
            target: 'table-0',
            placement: 'top',
            yOffset: -25
          },
          {
            tab: true,
            title: this.$t('market_view.tour_ten_title'),
            content: this.$t('market_view.tour_ten_content'),
            target: 'download-file-0-0',
            placement: 'left',
            xOffset: 60,
            yOffset: -10
          },
          {
            tab: true,
            title: this.$t('market_view.tour_eleven_title'),
            content: this.$t('market_view.tour_eleven_content'),
            target: 'paginate-0',
            placement: 'top',
            yOffset: 15,
            xOffset: 5
          }
        ])
      },
      logo: '',
      permFilters: {}
    }
  }
}
</script>
